import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
    cacheStorage
} from '@/utils'
// 开发环境
// // const API_BASE_URL = 'http://charge.ngrok.gznino.com:8080/'
// // const API_BASE_URL = 'http://192.168.1.7:91/'
// // const API_BASE_URL = 'https://charge.gzninuo.com/'
//创建实例
const instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 5000
});
//  interceptors 拦截器
// 添加请求拦截器
instance.interceptors.request.use(config => {
    if (store.state.auth) {
        let auth = store.state.auth.token
        if (auth) {
            config.headers.token = auth
        }
        /*let auth = cacheStorage.getItem(process.env.VUE_APP_AUTH_TOKEN)
        console.log('JSON.parse(auth):', auth)
        if (auth) {
            config.headers.token = auth
        }*/
        config.headers.tenancyId = store.state.auth.tenancyId
    }
    let userInfo = cacheStorage.getItem('user')

    if (userInfo) {
        userInfo = JSON.parse(userInfo)
        config.headers.userId = userInfo.id
    }
    return config
},
    err => {
        return Promise.reject(err)
    }
)
// 添加响应拦截器
instance.interceptors.response.use(response => {
    let data = response.data || response
    const {
        verifycodesession,
        token
    } = response.headers
    if (token) {
        store.dispatch('setToken', token)
    }
    if (response.config.headers.userId) {
        localStorage.setItem('userId', response.config.headers.userId)
    }
    // 10001表示token过期
    if (data.code === 10001 || data.code === 10003) {
        cacheStorage.clear()
        Vue.prototype.$toast.fail(response.data.message)
        // window.location.href = location.href.split('?')[0]
        // window.location.reload()
        location.href = location.href.split('?')[0] + `?wxCpType=${store.state.auth.cpType}`
    }
    if (verifycodesession) {
        sessionStorage.setItem('verifycodesession', verifycodesession)
    }
    return Promise.resolve(data)
},
    err => {
        // console.log(err.response);
        // if (err.response) {
        //     sessionStorage.clear()
        //     Vue.prototype.$toast.fail(err.response.data.message)
        // }
        return Promise.reject(err)
    }
)
Vue.prototype.$http = instance
export default instance
